import { render, staticRenderFns } from "./StatusDelivery.vue?vue&type=template&id=5d039c9a&scoped=true&"
import script from "./StatusDelivery.vue?vue&type=script&lang=js&"
export * from "./StatusDelivery.vue?vue&type=script&lang=js&"
import style0 from "./StatusDelivery.vue?vue&type=style&index=0&id=5d039c9a&lang=scss&scoped=true&"
import style1 from "./StatusDelivery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d039c9a",
  null
  
)

export default component.exports